import React, { useRef, useEffect } from 'react';
import { Field, Label, Control, Input } from "rbx";

const TextField = (props) => {
  const { name, label, placeholder=null, value, onChange, focus=false, children, ...other } = props;
  const textField = useRef();

  useEffect(()=>{
    if (focus)
      textField.current.focus();
  },[focus]);

  return (
    <>
      {(label) && <Label className="has-text-grey">{label}</Label>}
      <Field kind="addons">
        <Control expanded>
          <Input 
            type={name}
            ref={textField}
            placeholder={placeholder}
            name={name}
            value={value}
            onChange={onChange}
            {...other}
          />
        </Control>
        {children}
      </Field>
    </>
  )

}

export default TextField;
